<template>
    <!--begin::Error-->
    <div
        class="d-flex flex-column flex-column-fluid position-relative"
        style="background-color: #eaf9fc"
    >
        <!--begin::Background-->
        <div
            class="bgi-size-contain bgi-position-x-end bgi-position-y-center bgi-no-repeat position-absolute top-0 start-0 w-100 h-100 d-none d-lg-block bg-image-404"
        ></div>
        <!--end::Background-->
        <div
            class="px-10 px-md-20 py-10 py-md-0 d-flex flex-column justify-content-md-center align-items-start flex-root w-md-700px z-index-1"
        >
            <p class="display-6 fw-bolder text-gray-800 mb-8">
                {{ $t("error_page.something_went_wrong") }}
            </p>
            <p class="fs-6 mb-8">
                {{ $t("error_page.return_home_msg") }}
            </p>
            <router-link to="/" v-slot="{ href, navigate }">
                <a
                    :href="href"
                    @click="navigate"
                    class="btn btn-primary fs-6 fw-bolder py-4 px-6 mr-auto"
                    >{{ $t("error_page.return_home") }}</a
                >
            </router-link>
        </div>
        <!--end::Content-->
    </div>
    <!--end::Error-->
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
    name: "Error",
})
</script>
<style lang="scss">
@import "@/assets/sass/core/components/_variables.scss";

.bg-image-404 {
    background-image: asset("illustrations/404-hd.png");
}
</style>
